import React from 'react'
import './Header.css'

import Buttons from './Buttons'
import Socials from './Socials'

const Header = () => {
  return (
    <header id='Header'>
      <div className='container header__container'>
        <h5>Hello I'm</h5>
        <h1>Talha Amjad</h1>
        <h5 className='text-light'>Software Developer</h5>
        <Buttons />
        <Socials />

        {/* Replace this image with something else */}
        {/* <div className="myImage">
          <img src={profile} alt='' />
        </div> */}

        <a href='#Contact' className='scroll__down'>Scroll Down</a>

      </div>

    </header>
  )
}

export default Header